import { Table } from "reactstrap";
import InvoiceHeadData from "./InvoiceHeadData";
import { Image, LI, UL } from "../../../../../AbstractElements";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";
import { dynamicImage } from "../../../../../Utils";

const InvoiceHead = () => {
  return (
    <tr>
      <td>
        <Table borderless style={{ width: "100%" }}>
          <tbody>
            <tr style={{display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <td className="p-0">
              <Image className="img-fluid for-light" src={dynamicImage(`logo/logo-1.png`)} alt="looginpage" />
              <Image className="img-fluid for-dark" src={dynamicImage(`logo/logo.png`)} alt="looginpage" />
              </td>
              <td className="p-0">
                <UL className="simple-list flex-row" style={{ listStyle: "none", display: "flex", alignItems: "center", background: "linear-gradient(291deg,  #2A5699 21.2%, #2A5699 83.92%)", padding: "31px 80px", borderBottomLeftRadius: 100, gap: 28 }}>
                  <LI>
                    <SvgIcon className="stroke-icon" iconId="call" style={{ height: 14, width: 14, fill: "#fff", marginRight: 10 }} />
                    <span style={{ color: "#FFFFFF", fontWeight: 500, fontSize: 16 }}>(239) 555-0108</span>
                  </LI>
                  <LI style={{ borderLeft: "1px solid rgba(255, 255, 255, 0.3)", borderRight: "1px solid rgba(255, 255, 255, 0.3)", padding: "0 22px" }}>
                    <SvgIcon iconId="email-box" style={{ height: 16, width: 16, fill: "#fff", marginRight: 10 }} />
                    <span style={{ color: "#FFFFFF", fontWeight: 500, fontSize: 16 }}>berlin@themesforest.com</span>
                  </LI>
                  <LI>
                    <SvgIcon iconId="web" style={{ height: 16, width: 16, fill: "#fff", marginRight: 10 }} />
                    <span style={{ color: "#FFFFFF", fontWeight: 500, fontSize: 16 }}>Website: www.Berlinthemes.com</span>
                  </LI>
                </UL>
              </td>
            </tr>
            <InvoiceHeadData />
          </tbody>
        </Table>
      </td>
    </tr>
  );
};

export default InvoiceHead;
